<div class="container">
  <header class="header">
    <button class="back-button" (click)="goBack()">
      <span class="back-arrow">←</span>
    </button>
    <h1 class="header-text">Cookie Policy</h1>
  </header>
</div>